import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { PessoaModule, SharedModule } from 'eddydata-lib';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { FavorecidoDlgModule } from '../favorecido/favorecido-dlg.module';
import { SaldoFichaModule } from '../saldo-ficha/saldo-ficha.module';
import { ExclusaoRcmsDlgComponent } from './exclusao-rcms-dlg/exclusao-rcms-dlg.component';
import { RcmsCotacaoComponent } from './rcms-cotacao/rcms-cotacao.component';
import { RcmsFavorecidoComponent } from './rcms-favorecido/rcms-favorecido.component';
import { RcmsFormComponent } from './rcms-form/rcms-form.component';
import { RcmsItemComponent } from './rcms-item/rcms-item.component';
import { RcmsListComponent } from './rcms-list/rcms-list.component';
import { RcmsRoutingModule } from './rcms-routing.module';
import { RcmsViewComponent } from './rcms-view/rcms-view.component';


@NgModule({
  declarations: [RcmsFormComponent, RcmsListComponent, RcmsItemComponent,
    RcmsFavorecidoComponent, RcmsCotacaoComponent, ExclusaoRcmsDlgComponent, RcmsViewComponent],
  exports: [ExclusaoRcmsDlgComponent],
  imports: [
    CommonModule,
    RcmsRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    PessoaModule,
    RadioButtonModule,
    FieldsetModule,
    FavorecidoDlgModule,
    SelectButtonModule,
    SaldoFichaModule,
    DialogModule,
    ButtonModule,
    DragDropModule
  ],
  providers: [MessageService]
})
export class RcmsModule { }
